import { Controller } from "@hotwired/stimulus";

import ClipboardJS from "clipboard";

export default class extends Controller {
  static targets = ["source", "message"];

  connect() {
    this.clipboard = new ClipboardJS(this.element, {
      text: () => this.sourceTarget.textContent,
    });

    this.clipboard.on("success", () => {
      this.messageTarget.classList.remove("hidden");
      setTimeout(() => {
        this.messageTarget.classList.add("hidden");
      }, 3000);
    });
  }

  disconnect() {
    this.clipboard.destroy();
  }
}
